const form = document.querySelector('.js-ctm-form');

if (form) {
    form.addEventListener('submit', (event) => {
        event.preventDefault();

        const url = form.dataset.url;
        const gender = form.querySelector('input[name="gender"]:checked');
        const type = form.querySelector('input[name="type"]:checked');

        if (gender && type) {
            window.location.href = `${url}comparison/${type.value}?gender=${gender.value}`;
        } else {
            const message = form.querySelector('.ctm-hero__message');
            message.classList.add('ctm-hero__message--visible');
        }
    });
}
